import { useContext } from "react";
import { QuestionnaireContext } from "..";

export const useQuestionareContext = () => useContext(QuestionnaireContext);
